var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#636161",
    strokeWidth: 1.5,
    d: "M9.915 4.084v2.333a2.917 2.917 0 0 1-5.833 0V4.084a2.917 2.917 0 0 1 5.833 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#636161",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.665 6.417A4.667 4.667 0 0 1 7 11.084m0 0a4.667 4.667 0 0 1-4.667-4.667m4.667 4.667v1.75m0 0h1.75m-1.75 0h-1.75"
  })));
};
export default SvgMic;